/* unplugin-vue-components disabled */import script from "./AppgSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./AppgSpinner.vue?vue&type=script&setup=true&lang=js"

import "./AppgSpinner.vue?vue&type=style&index=0&id=ce3c7e02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce3c7e02"]])

export default __exports__